import { FaHeartBroken } from "react-icons/fa";

import { useNavigate } from "react-router-dom";

import "./EmptyFavorites.css";

function EmptyFavorites() {

    const navigate = useNavigate();

    return (

        <div className="empty-favorites">

            <div className="empty-icon">

                <FaHeartBroken />

            </div>

            <h2>

                No Favorites Yet

            </h2>

            <p>

                Save your favourite foods to order them quickly later.

            </p>

            <button

                onClick={() => navigate("/home")}

            >

                Browse Foods

            </button>

        </div>

    );

}

export default EmptyFavorites;